import { Pipe, PipeTransform } from '@angular/core';
import { planTypeDropdown } from '../consts/plan-type-dropdown';

@Pipe({
  name: 'planTypeDescription',
  standalone: true,
})
export class PlanTypeDescriptionPipe implements PipeTransform {
  transform(value: string[] | number): string {
    if (typeof value === 'number') {
      return this.getDescriptionById(value);
    }

    if (Array.isArray(value)) {
      const descriptions = value
        .map((item) => this.getDescriptionById(+item.trim()))
        .filter((desc, index, self) => self.indexOf(desc) === index); // Remove duplicates

      return descriptions.join(', ');
    }

    return '--';
  }

  private getDescriptionById(id: number): string {
    if (id === null || id === undefined || id === 0) {
      return '--';
    }

    const ref = planTypeDropdown().find((item) => item.id === id);
    return ref ? ref.description : '--';
  }
}
